import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { BankList, CampaignCategories, CampaignComments, CampaignDetails, CampaignList, CampaignUpdates, DonationList, FAQS, FilterCampaignList, TotalAmountRaised, UserCampaignList, VirtualAccount } from '../hooks/local/reducer';

export function useCampaignCategories() {
    const [campaignCategoryList, setCampaignCategoryList] = useState([])
    const dispatch = useDispatch();
    useEffect(() => {
      const fetchCampaignCategories = async() => {
        try {
            const {payload} = await dispatch(CampaignCategories());
            setCampaignCategoryList(payload.result);
        }
        catch(e){}
      }
      fetchCampaignCategories();
    }, [dispatch]);

    return campaignCategoryList;
}

export function useCampaignList() {
  const [listCampaign, setListCampaign] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchCampaignList = async() => {
      try {
          const {payload} = await dispatch(CampaignList());
          setListCampaign(payload.result);
          // console.log(payload);
      }
      catch(e){}
    }
    fetchCampaignList();
  }, [dispatch]);

  return listCampaign;
}

export function useFAQs() {
  const [listFAQs, setListFAQs] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchFAQs = async() => {
      try {
          const {payload} = await dispatch(FAQS());
          setListFAQs(payload.result);
          // console.log(payload);
      }
      catch(e){}
    }
    fetchFAQs();
  }, [dispatch]);

  return listFAQs;
}

export function useFilterCampaign(categoryID) {
  const [filterCampaign, setFilterCampaign] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchFilteredCampaign = async() => {
      try {
          const {payload} = await dispatch(FilterCampaignList(categoryID));
          setFilterCampaign(payload.result);
      }
      catch(e){}
    }
    fetchFilteredCampaign();
  }, [dispatch, categoryID]);

  return filterCampaign;
}

export function useTotalAmount() {
  const [totalAmount, setTotalAmount] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchTotalAmount = async() => {
      try {
          const {payload} = await dispatch(TotalAmountRaised());
          setTotalAmount(payload.total_amount);
          // console.log(payload.total_amount);
      }
      catch(e){}
    }
    fetchTotalAmount();
  }, [dispatch]);

  return totalAmount;
}

export function useCampaignDetail(campaignReference) {
  const [campaignDetail, setCampaignDetail] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchCampaignDetail = async() => {
      try {
          const {payload} = await dispatch(CampaignDetails(campaignReference));
          setCampaignDetail(payload.result[0]);
      }
      catch(e){}
    }
    fetchCampaignDetail();
  }, [dispatch, campaignReference]);

  return campaignDetail;
}

export function useCampaignComments(campaignReference) {
  const [campaignComments, setCampaignComments] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchCampaignComments = async() => {
      try {
          const {payload} = await dispatch(CampaignComments(campaignReference));
          setCampaignComments(payload.result);
          // console.log(payload.result)
      }
      catch(e){}
    }
    fetchCampaignComments();
  }, [dispatch, campaignReference]);

  return campaignComments;
}

export function useCampaignUpdates(campaignReference) {
  const [campaignUpdates, setCampaignUpdates] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchCampaignUpdates = async() => {
      try {
          const {payload} = await dispatch(CampaignUpdates(campaignReference));
          setCampaignUpdates(payload.result);
          // console.log(payload.result)
      }
      catch(e){}
    }
    fetchCampaignUpdates();
  }, [dispatch, campaignReference]);

  return campaignUpdates;
}

export function useDonationList(campaignReference) {
  const [donationList, setDonationList] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchDonationList = async() => {
      try {
          const {payload} = await dispatch(DonationList(campaignReference));
          setDonationList(payload.result);
          // console.log(payload.result)
      }
      catch(e){}
    }
    fetchDonationList();
  }, [dispatch, campaignReference]);

  return donationList;
}

export function useCampaignOwnerList(email) {
  const [campaignOwnerList, setCampaignOwnerList] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchDonationList = async() => {
      try {
          const {payload} = await dispatch(UserCampaignList(email));
          setCampaignOwnerList(payload.result);
      }
      catch(e){}
    }
    fetchDonationList();
  }, [dispatch, email]);

  return campaignOwnerList;
}

export function useVirtualAccountDetails(campaignReference) {
  const [virtualAccount, setVirtualAccount] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchVirtualAccount = async() => {
      try {
          const {payload} = await dispatch(VirtualAccount(campaignReference));
          setVirtualAccount(payload.result[0]);
          // console.log(payload.result)
      }
      catch(e){}
    }
    fetchVirtualAccount();
  }, [dispatch, campaignReference]);

  return virtualAccount;
}

export function useBankList() {
  const [listBanks, setListBanks] = useState([])
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchBankList = async() => {
      try {
          const {payload} = await dispatch(BankList());
          setListBanks(payload.result);
          // console.log(payload);
      }
      catch(e){}
    }
    fetchBankList();
  }, [dispatch]);

  return listBanks;
}
